export enum enumEntityDataSource {
  NEW = 'NEW',
  CN = 'CN',
  BY = 'BY',
  SE = 'SE',
  MF = 'MF',
  CS = 'CS',
  IM = 'IM',
  COMPANY = 'COMPANY',
}
